import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LanguageService } from '../../../_core/services/language.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  imports: [CommonModule, FormsModule, IonicModule]
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  currentLanguage = 'en';
  availableLanguages = [
    { code: 'en', name: 'English' },
    { code: 'sr', name: 'Srpski' },
    { code: 'hi', name: 'हिंदी' }
  ];

  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // Initialize current language from LanguageService
    this.currentLanguage = this.languageService.getCurrentLanguage();

    // Subscribe to language changes from the LanguageService
    this.languageService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe((lang) => {
        this.currentLanguage = lang;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  switchLanguage(lang: string) {
    //console.log("LanguageSelector: Switching to language:", lang);
    this.languageService.setLanguage(lang);
  }
}
